// «از روی کاغذ»: عکسِ پلانی که کاربر روی کاغذ کشیده → دیوارهای پلانِ دوبعدی. بدونِ هوش مصنوعی؛ پردازشِ تصویرِ
// کلاسیک، کاملاً روی خودِ گوشی:
//
//   ۱) پیدا کردنِ کاغذ (روشن‌ترین تکه‌ی بزرگِ عکس) و صاف کردنش (اصلاحِ کجی و پرسپکتیو)
//   ۲) جدا کردنِ خطِ خودکار از کاغذ (آستانه‌ی محلی — سایه و نورِ ناهمگون را تحمل می‌کند)
//   ۳) حذفِ نوشته‌ها و علامت‌های کوچک (تکه‌های کوچکِ جدا از شبکه‌ی دیوارها)
//   ۴) پیدا کردنِ جهتِ غالبِ خط‌ها و چرخاندنِ همه به افقی/عمودی
//   ۵) پیدا کردنِ خط‌های افقی و عمودیِ بلند (دست‌لرزه را تحمل می‌کند)، ادغامِ تکه‌های هم‌راستا، یکی کردنِ خط‌هایی
//      که تقریباً روی یک امتدادند، چسباندنِ سرِ دیوارها به هم (بستنِ درزها و بریدنِ اضافه‌ها)
//
// خروجی به پیکسلِ «تصویرِ صاف‌شده» است؛ مقیاس (سانتی‌متر) بعداً از متراژِ آگهی می‌آید (scaleToArea).

// ---------- کمکی‌ها ----------
function toGray(src) {
  const { width: w, height: h, data } = src;
  const g = new Float32Array(w * h);
  for (let i = 0, j = 0; i < g.length; i += 1, j += 4) g[i] = data[j] * 0.299 + data[j + 1] * 0.587 + data[j + 2] * 0.114;
  return g;
}

function otsu(g) {
  const hist = new Float64Array(256);
  for (let i = 0; i < g.length; i += 1) hist[Math.max(0, Math.min(255, g[i] | 0))] += 1;
  const total = g.length;
  let sum = 0;
  for (let i = 0; i < 256; i += 1) sum += i * hist[i];
  let sumB = 0;
  let wB = 0;
  let best = 0;
  let th = 128;
  for (let t = 0; t < 256; t += 1) {
    wB += hist[t];
    if (!wB) continue;
    const wF = total - wB;
    if (!wF) break;
    sumB += t * hist[t];
    const mB = sumB / wB;
    const mF = (sum - sumB) / wF;
    const v = wB * wF * (mB - mF) * (mB - mF);
    if (v > best) {
      best = v;
      th = t;
    }
  }
  return th;
}

// برچسبِ تکه‌های به‌هم‌پیوسته (۸ همسایه) → { labels, comps: [{ n, x0, y0, x1, y1 }] }
function components(mask, w, h) {
  const labels = new Int32Array(w * h).fill(-1);
  const comps = [];
  const stack = new Int32Array(w * h);
  for (let s = 0; s < mask.length; s += 1) {
    if (!mask[s] || labels[s] >= 0) continue;
    const id = comps.length;
    const c = { n: 0, x0: w, y0: h, x1: 0, y1: 0, sx: 0, sy: 0 };
    let sp = 0;
    stack[sp++] = s;
    labels[s] = id;
    while (sp) {
      const i = stack[--sp];
      const x = i % w;
      const y = (i - x) / w;
      c.n += 1;
      c.sx += x;
      c.sy += y;
      if (x < c.x0) c.x0 = x;
      if (x > c.x1) c.x1 = x;
      if (y < c.y0) c.y0 = y;
      if (y > c.y1) c.y1 = y;
      for (let dy = -1; dy <= 1; dy += 1) {
        const yy = y + dy;
        if (yy < 0 || yy >= h) continue;
        for (let dx = -1; dx <= 1; dx += 1) {
          const xx = x + dx;
          if (xx < 0 || xx >= w) continue;
          const j = yy * w + xx;
          if (mask[j] && labels[j] < 0) {
            labels[j] = id;
            stack[sp++] = j;
          }
        }
      }
    }
    comps.push(c);
  }
  return { labels, comps };
}

// ماتریسِ تبدیلِ پرسپکتیو: چهار نقطه‌ی src → چهار نقطه‌ی dst (حلِ دستگاهِ ۸ معادله)
function homography(src, dst) {
  const A = [];
  const b = [];
  for (let k = 0; k < 4; k += 1) {
    const [x, y] = src[k];
    const [u, v] = dst[k];
    A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]);
    b.push(u);
    A.push([0, 0, 0, x, y, 1, -v * x, -v * y]);
    b.push(v);
  }
  // حذفِ گاوسی
  const n = 8;
  for (let i = 0; i < n; i += 1) {
    let p = i;
    for (let r = i + 1; r < n; r += 1) if (Math.abs(A[r][i]) > Math.abs(A[p][i])) p = r;
    [A[i], A[p]] = [A[p], A[i]];
    [b[i], b[p]] = [b[p], b[i]];
    const d = A[i][i] || 1e-12;
    for (let r = 0; r < n; r += 1) {
      if (r === i) continue;
      const f = A[r][i] / d;
      if (!f) continue;
      for (let c = i; c < n; c += 1) A[r][c] -= f * A[i][c];
      b[r] -= f * b[i];
    }
  }
  const hm = b.map((v, i) => v / A[i][i]);
  return [hm[0], hm[1], hm[2], hm[3], hm[4], hm[5], hm[6], hm[7], 1];
}

function sampleRGBA(src, x, y, out, o) {
  const { width: w, height: h, data } = src;
  const x0 = Math.max(0, Math.min(w - 1, Math.floor(x)));
  const y0 = Math.max(0, Math.min(h - 1, Math.floor(y)));
  const x1 = Math.min(w - 1, x0 + 1);
  const y1 = Math.min(h - 1, y0 + 1);
  const fx = Math.max(0, Math.min(1, x - x0));
  const fy = Math.max(0, Math.min(1, y - y0));
  for (let c = 0; c < 3; c += 1) {
    const a = data[(y0 * w + x0) * 4 + c];
    const bb = data[(y0 * w + x1) * 4 + c];
    const cc = data[(y1 * w + x0) * 4 + c];
    const d = data[(y1 * w + x1) * 4 + c];
    out[o + c] = (a * (1 - fx) + bb * fx) * (1 - fy) + (cc * (1 - fx) + d * fx) * fy;
  }
  out[o + 3] = 255;
}

// ---------- ۱) کاغذ ----------
// → { quad (چهار گوشه یا null), rows: [minX, maxX] برای هر سطر یا null (محدوده‌ی کاغذ) }
function findPaper(src) {
  const { width: w, height: h, data } = src;
  const g = toGray(src);
  const th = otsu(g);
  // کاغذ: روشن و بی‌رنگ (میزِ چوبی/پارچه رنگ دارد؛ سایه فقط تیره‌اش می‌کند، رنگش را نه)
  const mask = new Uint8Array(w * h);
  for (let i = 0, j = 0; i < g.length; i += 1, j += 4) {
    const mx = Math.max(data[j], data[j + 1], data[j + 2]);
    const mn = Math.min(data[j], data[j + 1], data[j + 2]);
    const sat = mx ? (mx - mn) / mx : 0;
    mask[i] = sat < 0.2 && g[i] > th * 0.55 ? 1 : 0;
  }
  // روشن‌ترین تکه‌ی بزرگ = کاغذ (خطوطِ داخلش سوراخ‌اند؛ مهم نیست، فقط گوشه‌ها را لازم داریم)
  const { labels, comps } = components(mask, w, h);
  let best = -1;
  comps.forEach((c, i) => {
    if (best < 0 || c.n > comps[best].n) best = i;
  });
  if (best < 0) return { quad: null, rows: null };
  const c = comps[best];
  const frac = c.n / (w * h);
  if (frac < 0.15) return { quad: null, rows: null };
  // محدوده‌ی کاغذ در هر سطر (برای وقتی که صاف کردن ممکن نشد: خط‌های بیرون از کاغذ — بافتِ میز — حساب نشوند)
  const rows = new Int32Array(h * 2).fill(-1);
  for (let i = 0; i < labels.length; i += 1) {
    if (labels[i] !== best) continue;
    const x = i % w;
    const y = (i - x) / w;
    if (rows[y * 2] < 0 || x < rows[y * 2]) rows[y * 2] = x;
    if (x > rows[y * 2 + 1]) rows[y * 2 + 1] = x;
  }
  // اگر کاغذ کلِ عکس را گرفته (از نزدیک)، صاف کردن لازم نیست
  if (c.x0 <= 2 && c.y0 <= 2 && c.x1 >= w - 3 && c.y1 >= h - 3) return { quad: null, rows: null };
  // گوشه‌ها: نقاطِ «اکسترمم» در چهار قطر
  let tl = null;
  let tr = null;
  let br = null;
  let bl = null;
  let vtl = Infinity;
  let vtr = -Infinity;
  let vbr = -Infinity;
  let vbl = Infinity;
  for (let i = 0; i < labels.length; i += 1) {
    if (labels[i] !== best) continue;
    const x = i % w;
    const y = (i - x) / w;
    if (x + y < vtl) {
      vtl = x + y;
      tl = [x, y];
    }
    if (x - y > vtr) {
      vtr = x - y;
      tr = [x, y];
    }
    if (x + y > vbr) {
      vbr = x + y;
      br = [x, y];
    }
    if (x - y < vbl) {
      vbl = x - y;
      bl = [x, y];
    }
  }
  const quad = [tl, tr, br, bl];
  // چهارضلعیِ گوشه‌ها باید تقریباً همه‌ی کاغذ را بپوشاند؛ وگرنه (کاغذِ تا خورده، بیرون‌زده از عکس، دست روی کاغذ)
  // صاف کردن را کنار می‌گذاریم و فقط چرخش اصلاح می‌شود
  let area2 = 0;
  for (let k = 0; k < 4; k += 1) {
    const [x0, y0] = quad[k];
    const [x1, y1] = quad[(k + 1) % 4];
    area2 += x0 * y1 - x1 * y0;
  }
  const quadArea = Math.abs(area2) / 2;
  if (quadArea < c.n * 0.92 || quadArea > c.n * 1.3) return { quad: null, rows };
  return { quad, rows };
}

function warpPaper(src, quad, maxSide) {
  const d = (a, b) => Math.hypot(a[0] - b[0], a[1] - b[1]);
  const [tl, tr, br, bl] = quad;
  let W = (d(tl, tr) + d(bl, br)) / 2;
  let H = (d(tl, bl) + d(tr, br)) / 2;
  const s = Math.min(1, maxSide / Math.max(W, H));
  W = Math.max(50, Math.round(W * s));
  H = Math.max(50, Math.round(H * s));
  // کمی از لبه‌ها داخل‌تر (سایه‌ی لبه‌ی کاغذ و میزِ زیرش خط حساب نشود)
  const m = 0.012;
  const dst = [
    [-W * m, -H * m],
    [W * (1 + m), -H * m],
    [W * (1 + m), H * (1 + m)],
    [-W * m, H * (1 + m)],
  ];
  const Hm = homography(dst, [tl, tr, br, bl]); // مقصد → مبدأ
  const out = new Uint8ClampedArray(W * H * 4);
  for (let y = 0; y < H; y += 1) {
    for (let x = 0; x < W; x += 1) {
      const z = Hm[6] * x + Hm[7] * y + 1;
      const sx = (Hm[0] * x + Hm[1] * y + Hm[2]) / z;
      const sy = (Hm[3] * x + Hm[4] * y + Hm[5]) / z;
      sampleRGBA(src, sx, sy, out, (y * W + x) * 4);
    }
  }
  return { width: W, height: H, data: out };
}

function resize(src, maxSide) {
  const s = Math.min(1, maxSide / Math.max(src.width, src.height));
  if (s >= 1) return src;
  const W = Math.round(src.width * s);
  const H = Math.round(src.height * s);
  const out = new Uint8ClampedArray(W * H * 4);
  // میانگینِ ساده (جعبه‌ای) برای کوچک کردن بدونِ دندانه
  const inv = 1 / s;
  for (let y = 0; y < H; y += 1) {
    for (let x = 0; x < W; x += 1) {
      const x0 = Math.floor(x * inv);
      const y0 = Math.floor(y * inv);
      const x1 = Math.min(src.width, Math.floor((x + 1) * inv));
      const y1 = Math.min(src.height, Math.floor((y + 1) * inv));
      let r = 0;
      let g = 0;
      let b = 0;
      let n = 0;
      for (let yy = y0; yy < y1; yy += 1) {
        for (let xx = x0; xx < x1; xx += 1) {
          const k = (yy * src.width + xx) * 4;
          r += src.data[k];
          g += src.data[k + 1];
          b += src.data[k + 2];
          n += 1;
        }
      }
      const o = (y * W + x) * 4;
      out[o] = r / n;
      out[o + 1] = g / n;
      out[o + 2] = b / n;
      out[o + 3] = 255;
    }
  }
  return { width: W, height: H, data: out };
}

// ---------- ۲) خطِ خودکار ----------
function inkMask(img, sensitivity = 1) {
  const { width: w, height: h } = img;
  const g = toGray(img);
  // میانگینِ محلی با جدولِ انتگرالی
  const I = new Float64Array((w + 1) * (h + 1));
  for (let y = 0; y < h; y += 1) {
    let row = 0;
    for (let x = 0; x < w; x += 1) {
      row += g[y * w + x];
      I[(y + 1) * (w + 1) + x + 1] = I[y * (w + 1) + x + 1] + row;
    }
  }
  const r = Math.max(8, Math.round(Math.min(w, h) / 22));
  const mask = new Uint8Array(w * h);
  for (let y = 0; y < h; y += 1) {
    const y0 = Math.max(0, y - r);
    const y1 = Math.min(h, y + r + 1);
    for (let x = 0; x < w; x += 1) {
      const x0 = Math.max(0, x - r);
      const x1 = Math.min(w, x + r + 1);
      const sum = I[y1 * (w + 1) + x1] - I[y0 * (w + 1) + x1] - I[y1 * (w + 1) + x0] + I[y0 * (w + 1) + x0];
      const mean = sum / ((x1 - x0) * (y1 - y0));
      // تیره‌تر از اطراف به اندازه‌ی کافی = جوهر (حساسیتِ بیشتر برای مدادِ کم‌رنگ)
      mask[y * w + x] = g[y * w + x] < mean * (1 - 0.1 / sensitivity) - 3 ? 1 : 0;
    }
  }
  return mask;
}

// ---------- ۳) فقط شبکه‌ی دیوارها ----------
function keepLargeStrokes(mask, w, h) {
  const { labels, comps } = components(mask, w, h);
  const minSide = Math.min(w, h);
  // لکه‌های پُر (سایه، میزِ بیرون از کاغذ، انگشت) خط نیستند: بعد از «لاغر کردن» هنوز چیزی از آن‌ها می‌ماند؛ خط‌ها
  // کاملاً محو می‌شوند
  const e = Math.max(4, Math.round(minSide * 0.012));
  const inv = new Uint8Array(w * h);
  for (let i = 0; i < inv.length; i += 1) inv[i] = mask[i] ? 0 : 1;
  const grown = dilate(inv, w, h, e); // پسِ‌زمینه پهن = جوهر لاغر
  const core = new Int32Array(comps.length);
  for (let i = 0; i < grown.length; i += 1) if (!grown[i] && labels[i] >= 0) core[labels[i]] += 1;
  const keep = comps.map((c, k) => Math.max(c.x1 - c.x0, c.y1 - c.y0) >= minSide * 0.12 && core[k] < c.n * 0.08);
  const out = new Uint8Array(w * h);
  for (let i = 0; i < out.length; i += 1) if (labels[i] >= 0 && keep[labels[i]]) out[i] = 1;
  return out;
}

// ---------- ۴) جهتِ غالب ----------
// زاویه‌ای که در آن «سایه»ی خط‌ها روی دو محور تیزترین قله‌ها را دارد (خطِ افقی/عمودیِ صاف = یک ستونِ بلند در
// نمودار) — بینِ −۲۰ تا +۲۰ درجه
function dominantAngle(mask, w, h) {
  const pts = [];
  const step = Math.max(1, Math.round(Math.sqrt((w * h) / 120000)));
  const bx = Math.round(w * 0.02);
  const by = Math.round(h * 0.02);
  for (let y = by; y < h - by; y += step) for (let x = bx; x < w - bx; x += step) if (mask[y * w + x]) pts.push(x, y);
  if (pts.length < 40) return 0;
  const n = Math.max(w, h) * 2;
  const score = (deg) => {
    const a = (deg * Math.PI) / 180;
    const c = Math.cos(a);
    const s = Math.sin(a);
    const hy = new Float64Array(n);
    const hx = new Float64Array(n);
    for (let i = 0; i < pts.length; i += 2) {
      const x = pts[i] - w / 2;
      const y = pts[i + 1] - h / 2;
      const yr = Math.round(-s * x + c * y + n / 2);
      const xr = Math.round(c * x + s * y + n / 2);
      if (yr >= 0 && yr < n) hy[yr] += 1;
      if (xr >= 0 && xr < n) hx[xr] += 1;
    }
    let v = 0;
    for (let i = 0; i < n; i += 1) v += hy[i] * hy[i] + hx[i] * hx[i];
    return v;
  };
  let best = 0;
  let bv = -1;
  for (let d = -20; d <= 20; d += 1) {
    const v = score(d);
    if (v > bv) {
      bv = v;
      best = d;
    }
  }
  for (let d = best - 1; d <= best + 1; d += 0.1) {
    const v = score(d);
    if (v > bv) {
      bv = v;
      best = d;
    }
  }
  return (best * Math.PI) / 180;
}

function rotateImage(img, angle, nearestMask = false) {
  const { width: w, height: h } = img;
  const c = Math.cos(angle);
  const s = Math.sin(angle);
  const W = Math.ceil(Math.abs(w * c) + Math.abs(h * s));
  const H = Math.ceil(Math.abs(w * s) + Math.abs(h * c));
  const cx = w / 2;
  const cy = h / 2;
  const CX = W / 2;
  const CY = H / 2;
  if (nearestMask) {
    const out = new Uint8Array(W * H);
    for (let y = 0; y < H; y += 1) {
      for (let x = 0; x < W; x += 1) {
        const dx = x - CX;
        const dy = y - CY;
        const sx = Math.round(c * dx - s * dy + cx);
        const sy = Math.round(s * dx + c * dy + cy);
        if (sx >= 0 && sy >= 0 && sx < w && sy < h) out[y * W + x] = img.data[sy * w + sx];
      }
    }
    return { width: W, height: H, data: out };
  }
  const out = new Uint8ClampedArray(W * H * 4);
  for (let y = 0; y < H; y += 1) {
    for (let x = 0; x < W; x += 1) {
      const dx = x - CX;
      const dy = y - CY;
      const sx = c * dx - s * dy + cx;
      const sy = s * dx + c * dy + cy;
      const o = (y * W + x) * 4;
      if (sx >= 0 && sy >= 0 && sx < w - 1 && sy < h - 1) sampleRGBA(img, sx, sy, out, o);
      else {
        out[o] = 245;
        out[o + 1] = 245;
        out[o + 2] = 245;
        out[o + 3] = 255;
      }
    }
  }
  return { width: W, height: H, data: out };
}

function dilate(mask, w, h, r) {
  if (r <= 0) return mask;
  // جداپذیر: افقی بعد عمودی (مربع)
  const tmp = new Uint8Array(w * h);
  for (let y = 0; y < h; y += 1) {
    let last = -1e9;
    for (let x = 0; x < w; x += 1) if (mask[y * w + x]) last = x;
    // دو گذر برای پوششِ دو طرف
    last = -1e9;
    for (let x = 0; x < w; x += 1) {
      if (mask[y * w + x]) last = x;
      if (x - last <= r) tmp[y * w + x] = 1;
    }
    last = 1e9;
    for (let x = w - 1; x >= 0; x -= 1) {
      if (mask[y * w + x]) last = x;
      if (last - x <= r) tmp[y * w + x] = 1;
    }
  }
  const out = new Uint8Array(w * h);
  for (let x = 0; x < w; x += 1) {
    let last = -1e9;
    for (let y = 0; y < h; y += 1) {
      if (tmp[y * w + x]) last = y;
      if (y - last <= r) out[y * w + x] = 1;
    }
    last = 1e9;
    for (let y = h - 1; y >= 0; y -= 1) {
      if (tmp[y * w + x]) last = y;
      if (last - y <= r) out[y * w + x] = 1;
    }
  }
  return out;
}

// ---------- ۵) خط‌های افقی/عمودی ----------
// horizontal=true: سطرها؛ وگرنه ستون‌ها. → [{ c (مختصاتِ ثابت), a, b (بازه), len }]
function longRuns(mask, w, h, minLen, horizontal) {
  const runMask = new Uint8Array(w * h);
  const outer = horizontal ? h : w;
  const inner = horizontal ? w : h;
  const at = horizontal ? (o, i) => o * w + i : (o, i) => i * w + o;
  for (let o = 0; o < outer; o += 1) {
    let start = -1;
    for (let i = 0; i <= inner; i += 1) {
      const on = i < inner && mask[at(o, i)];
      if (on && start < 0) start = i;
      if (!on && start >= 0) {
        if (i - start >= minLen) for (let k = start; k < i; k += 1) runMask[at(o, k)] = 1;
        start = -1;
      }
    }
  }
  const { labels, comps } = components(runMask, w, h);
  const segs = comps.map((c) => {
    const thick = horizontal ? c.y1 - c.y0 + 1 : c.x1 - c.x0 + 1;
    return horizontal
      ? { c: c.sy / c.n, a: c.x0, b: c.x1, len: c.x1 - c.x0, thick }
      : { c: c.sx / c.n, a: c.y0, b: c.y1, len: c.y1 - c.y0, thick };
  });
  void labels;
  return segs.filter((s) => s.len >= minLen);
}

// تکه‌های هم‌امتداد و نزدیک → یکی
function mergeCollinear(segs, tolC, gap) {
  const list = segs.slice().sort((p, q) => p.c - q.c || p.a - q.a);
  let changed = true;
  while (changed) {
    changed = false;
    outer: for (let i = 0; i < list.length; i += 1) {
      for (let j = i + 1; j < list.length; j += 1) {
        const p = list[i];
        const q = list[j];
        if (Math.abs(p.c - q.c) > tolC) continue;
        if (q.a > p.b + gap || p.a > q.b + gap) continue;
        const L = p.len + q.len;
        list[i] = { c: (p.c * p.len + q.c * q.len) / L, a: Math.min(p.a, q.a), b: Math.max(p.b, q.b), len: 0 };
        list[i].len = list[i].b - list[i].a;
        list.splice(j, 1);
        changed = true;
        break outer;
      }
    }
  }
  return list;
}

// خط‌هایی که تقریباً روی یک امتدادند (مثلاً دیوارِ پایینِ دو اتاقِ کنارِ هم) → دقیقاً یک امتداد
function alignAxes(segs, tol) {
  const sorted = segs.slice().sort((p, q) => p.c - q.c);
  const groups = [];
  sorted.forEach((s) => {
    const g = groups[groups.length - 1];
    if (g && Math.abs(s.c - g.c) <= tol) {
      g.items.push(s);
      const L = g.items.reduce((sum, x) => sum + x.len, 0);
      g.c = g.items.reduce((sum, x) => sum + x.c * x.len, 0) / L;
    } else groups.push({ c: s.c, items: [s] });
  });
  groups.forEach((g) => g.items.forEach((s) => (s.c = g.c)));
  return sorted;
}

// سرِ هر خط به نزدیک‌ترین خطِ عمود (درز بسته، اضافه بریده)
function snapEnds(H, V, tol) {
  const snapFamily = (A, B) => {
    A.forEach((s) => {
      ['a', 'b'].forEach((end) => {
        const pos = s[end];
        let best = null;
        B.forEach((t) => {
          // خطِ عمود باید از امتدادِ این خط (با کمی تحمل) رد شود
          if (s.c < t.a - tol || s.c > t.b + tol) return;
          const d = Math.abs(t.c - pos);
          if (d <= tol && (!best || d < best.d)) best = { d, t };
        });
        if (best) {
          s[end] = best.t.c;
          // خطِ عمود هم اگر کوتاه‌تر بود تا این‌جا می‌آید
          if (s.c < best.t.a) best.t.a = s.c;
          if (s.c > best.t.b) best.t.b = s.c;
        }
      });
      if (s.a > s.b) [s.a, s.b] = [s.b, s.a];
      s.len = s.b - s.a;
    });
  };
  for (let k = 0; k < 2; k += 1) {
    snapFamily(H, V);
    snapFamily(V, H);
  }
}

// ---------- همه با هم ----------
// src: { width, height, data (RGBA) } — عکسِ اصلی. → { image (صاف‌شده و چرخیده، برای زیرِ پلان), walls (پیکسل) }
export function sketchToWalls(src, { sensitivity = 1, maxSide = 1200 } = {}) {
  const small = resize(src, 1400);
  const paper = findPaper(small);
  const quad = paper.quad;
  let img = quad ? warpPaper(small, quad, maxSide) : resize(small, maxSide);
  const w0 = img.width;
  const h0 = img.height;
  let ink = inkMask(img, sensitivity);
  // صاف نشد ولی کاغذ پیدا شد: فقط داخلِ کاغذ (با کمی فاصله از لبه‌اش)
  if (!quad && paper.rows) {
    const k = small.width / w0;
    const pad = Math.round(Math.min(w0, h0) * 0.02);
    for (let y = 0; y < h0; y += 1) {
      const sy = Math.min(small.height - 1, Math.round(y * k));
      const a = paper.rows[sy * 2] / k + pad;
      const b = paper.rows[sy * 2 + 1] / k - pad;
      for (let x = 0; x < w0; x += 1) if (paper.rows[sy * 2] < 0 || x < a || x > b) ink[y * w0 + x] = 0;
    }
    // سطرهای بالا و پایینِ کاغذ
    let top = 0;
    while (top < small.height && paper.rows[top * 2] < 0) top += 1;
    let bottom = small.height - 1;
    while (bottom > 0 && paper.rows[bottom * 2] < 0) bottom -= 1;
    const t = top / k + pad;
    const bt = bottom / k - pad;
    for (let y = 0; y < h0; y += 1) if (y < t || y > bt) for (let x = 0; x < w0; x += 1) ink[y * w0 + x] = 0;
  }
  // خطِ نازک/کم‌رنگ (مداد) تکه‌تکه دیده می‌شود — اول کمی پهن، بعد تکه‌های کوچک (نوشته) حذف
  const r0 = Math.max(1, Math.round(Math.min(w0, h0) * 0.003));
  const inkD = dilate(ink, w0, h0, r0);
  let mask = keepLargeStrokes(inkD, w0, h0);
  // تکه‌های کوچک = نوشته‌ها (اسمِ اتاق‌ها، «ورودی»، فلش) — جدا نگه می‌داریم
  let textInk = new Uint8Array(w0 * h0);
  for (let i = 0; i < textInk.length; i += 1) textInk[i] = inkD[i] && !mask[i] ? 1 : 0;
  const angle = dominantAngle(mask, w0, h0);
  if (Math.abs(angle) > 0.003) {
    img = rotateImage(img, angle);
    mask = rotateImage({ width: w0, height: h0, data: mask }, angle, true).data;
    textInk = rotateImage({ width: w0, height: h0, data: textInk }, angle, true).data;
  }
  const w = img.width;
  const h = img.height;
  const minSide = Math.min(w, h);
  const r = Math.max(2, Math.round(minSide * 0.004));
  // قوس‌ها اول — و جوهرشان پاک می‌شود تا خطِ افقی/عمودیِ اشتباهی رویشان ساخته نشود (و کشیده نشود تا دیوارِ روبه‌رو)
  const arcFits = detectArcs(mask, w, h, minSide);
  if (arcFits.length) mask = eraseArcs(mask, w, h, arcFits, Math.max(4, Math.round(minSide * 0.012)));
  const thick = dilate(mask, w, h, r);
  const minLen = Math.max(20, Math.round(minSide * 0.05));
  let H = longRuns(thick, w, h, minLen, true);
  let V = longRuns(thick, w, h, minLen, false);
  const tolC = minSide * 0.018;
  H = alignAxes(mergeCollinear(H, tolC, minSide * 0.03), tolC);
  V = alignAxes(mergeCollinear(V, tolC, minSide * 0.03), tolC);
  snapEnds(H, V, minSide * 0.035);
  // ادغامِ دوباره بعد از چسباندن (دو تکه‌ی یک دیوار که حالا به هم رسیده‌اند)
  H = mergeCollinear(H, 0.5, 1);
  V = mergeCollinear(V, 0.5, 1);
  const minWall = minSide * 0.03;
  let walls = [
    ...H.filter((s) => s.len >= minWall).map((s) => ({ x1: s.a, y1: s.c, x2: s.b, y2: s.c })),
    ...V.filter((s) => s.len >= minWall).map((s) => ({ x1: s.c, y1: s.a, x2: s.c, y2: s.b })),
  ];
  // قوس‌های پیداشده (سرها روی دیوارهای صافِ کنارشان) + دیوارهای مورب (جوهری که هیچ خطِ افقی/عمودی پوشش نداد)
  walls = placeArcs(arcFits, walls, minSide);
  walls = findCurves(mask, thick, w, h, walls, minSide);
  walls = foldStubs(walls, minSide);
  return { image: img, walls, labels: findLabels(textInk, w, h), paperFound: Boolean(quad), angle };
}

// ---------- ۷) دیوارهای منحنی و مورب ----------
// ۱) جوهرِ باقی‌مانده = خط‌ها منهای جاهایی که دیوارِ افقی/عمودی پیدا شد → تکه‌های منحنی/مورب
// ۲) هر تکه: دایره (یا خطِ راست) به نقطه‌هایش برازش می‌شود؛ تکه‌هایی که روی یک دایره‌اند یکی می‌شوند
// ۳) بازه‌ی زاویه‌ایِ قوس از نقطه‌ها (+ ادامه تا جایی که جوهر هست)، سرها روی دیوارهای کنارش می‌نشینند
// ۴) خطِ افقی/عمودیِ کوتاهی که در واقع بخشی از همین قوس بود (مثلاً روی بالاترین نقطه‌ی قوس) حذف می‌شود
// خروجی: دیوار با arc (خیز، پیکسل) — همان قراردادِ arcWalls.jsx
function fitCircle(px) {
  // کاسا: x² + y² + D x + E y + F = 0 (حداقلِ مربعات)
  let sx = 0;
  let sy = 0;
  let sxx = 0;
  let syy = 0;
  let sxy = 0;
  let sz = 0;
  let sxz = 0;
  let syz = 0;
  const n = px.length;
  px.forEach(([x, y]) => {
    const z = x * x + y * y;
    sx += x;
    sy += y;
    sxx += x * x;
    syy += y * y;
    sxy += x * y;
    sz += z;
    sxz += x * z;
    syz += y * z;
  });
  // [sxx sxy sx; sxy syy sy; sx sy n] [D E F]ᵀ = −[sxz syz sz]ᵀ
  const A = [
    [sxx, sxy, sx],
    [sxy, syy, sy],
    [sx, sy, n],
  ];
  const b = [-sxz, -syz, -sz];
  const det = (M) =>
    M[0][0] * (M[1][1] * M[2][2] - M[1][2] * M[2][1]) - M[0][1] * (M[1][0] * M[2][2] - M[1][2] * M[2][0]) + M[0][2] * (M[1][0] * M[2][1] - M[1][1] * M[2][0]);
  const d0 = det(A);
  if (Math.abs(d0) < 1e-6) return null;
  const col = (k) => A.map((row, i) => row.map((v, j) => (j === k ? b[i] : v)));
  const D = det(col(0)) / d0;
  const E = det(col(1)) / d0;
  const F = det(col(2)) / d0;
  const cx = -D / 2;
  const cy = -E / 2;
  const r2 = cx * cx + cy * cy - F;
  if (!(r2 > 0)) return null;
  const R = Math.sqrt(r2);
  let err = 0;
  px.forEach(([x, y]) => {
    err += (Math.hypot(x - cx, y - cy) - R) ** 2;
  });
  return { cx, cy, R, rms: Math.sqrt(err / n) };
}

function fitLine(px) {
  const n = px.length;
  const mx = px.reduce((a, p) => a + p[0], 0) / n;
  const my = px.reduce((a, p) => a + p[1], 0) / n;
  let xx = 0;
  let yy = 0;
  let xy = 0;
  px.forEach(([x, y]) => {
    xx += (x - mx) ** 2;
    yy += (y - my) ** 2;
    xy += (x - mx) * (y - my);
  });
  const ang = 0.5 * Math.atan2(2 * xy, xx - yy);
  const ux = Math.cos(ang);
  const uy = Math.sin(ang);
  let lo = Infinity;
  let hi = -Infinity;
  let err = 0;
  px.forEach(([x, y]) => {
    const t = (x - mx) * ux + (y - my) * uy;
    lo = Math.min(lo, t);
    hi = Math.max(hi, t);
    err += ((x - mx) * -uy + (y - my) * ux) ** 2;
  });
  return { x1: mx + ux * lo, y1: my + uy * lo, x2: mx + ux * hi, y2: my + uy * hi, len: hi - lo, rms: Math.sqrt(err / n) };
}

const normAng = (a) => ((a % (Math.PI * 2)) + Math.PI * 2) % (Math.PI * 2);

function findCurves(mask, thick, w, h, walls, minSide) {
  // ۱) پوششِ دیوارهای افقی/عمودی
  const cover = new Uint8Array(w * h);
  const rr = Math.max(3, Math.round(minSide * 0.014));
  walls.forEach((s) => {
    const x0 = Math.max(0, Math.floor(Math.min(s.x1, s.x2) - rr));
    const x1 = Math.min(w - 1, Math.ceil(Math.max(s.x1, s.x2) + rr));
    const y0 = Math.max(0, Math.floor(Math.min(s.y1, s.y2) - rr));
    const y1 = Math.min(h - 1, Math.ceil(Math.max(s.y1, s.y2) + rr));
    for (let y = y0; y <= y1; y += 1) for (let x = x0; x <= x1; x += 1) cover[y * w + x] = 1;
  });
  const rest = new Uint8Array(w * h);
  for (let i = 0; i < rest.length; i += 1) rest[i] = mask[i] && !cover[i] ? 1 : 0;
  const { labels, comps } = components(rest, w, h);
  const minFrag = minSide * 0.05;
  const frags = [];
  comps.forEach((c, k) => {
    if (Math.max(c.x1 - c.x0, c.y1 - c.y0) < minFrag) return;
    const step = Math.max(1, Math.floor(c.n / 600));
    const px = [];
    let cnt = 0;
    for (let y = c.y0; y <= c.y1; y += 1) {
      for (let x = c.x0; x <= c.x1; x += 1) {
        if (labels[y * w + x] === k) {
          if (cnt % step === 0) px.push([x, y]);
          cnt += 1;
        }
      }
    }
    frags.push(px);
  });
  if (!frags.length) return walls;

  const tolFit = Math.max(2.5, minSide * 0.012);
  const joinTol = minSide * 0.035;
  // «زنجیره»: از هر تکه‌ی باقی‌مانده شروع می‌کنیم و تکه‌های همسایه (و خطِ صافِ کوتاهی که شاید وسطِ همان قوس پیدا
  // شده بود) را تا وقتی همه با هم روی یک دایره می‌مانند اضافه می‌کنیم
  const samples = (sg) => {
    const L = Math.hypot(sg.x2 - sg.x1, sg.y2 - sg.y1);
    const n = Math.max(2, Math.round(L / 3));
    return Array.from({ length: n + 1 }, (_, k) => [sg.x1 + ((sg.x2 - sg.x1) * k) / n, sg.y1 + ((sg.y2 - sg.y1) * k) / n]);
  };
  const items = [
    ...frags.map((px) => {
      const L = fitLine(px);
      return { kind: 'f', px, ends: [[L.x1, L.y1], [L.x2, L.y2]] };
    }),
    ...walls
      .map((sg, wi) => ({ sg, wi }))
      .filter(({ sg }) => Math.hypot(sg.x2 - sg.x1, sg.y2 - sg.y1) < minSide * 0.45)
      .map(({ sg, wi }) => ({ kind: 'w', wi, px: samples(sg), ends: [[sg.x1, sg.y1], [sg.x2, sg.y2]] })),
  ];
  const near = (a, chain) =>
    chain.some((c) => c.ends.some(([x1, y1]) => a.ends.some(([x2, y2]) => Math.hypot(x1 - x2, y1 - y2) <= joinTol)));
  const used = new Set();
  const circles = [];
  const lines = [];
  items.forEach((start, si) => {
    if (start.kind !== 'f' || used.has(si)) return;
    used.add(si);
    const chain = [start];
    let pts = start.px.slice();
    let changed = true;
    while (changed) {
      changed = false;
      items.forEach((it, ii) => {
        if (used.has(ii) || !near(it, chain)) return;
        const trial = pts.concat(it.px);
        const C = fitCircle(trial);
        if (C && C.rms <= tolFit && C.R < minSide * 3) {
          chain.push(it);
          used.add(ii);
          pts = trial;
          changed = true;
        }
      });
    }
    const C = pts.length >= 8 ? fitCircle(pts) : null;
    const L = fitLine(pts);
    const isArc = C && C.rms <= tolFit && C.R < minSide * 3 && L.rms > Math.max(C.rms * 1.8, tolFit * 0.45);
    if (isArc) circles.push({ ...C, px: pts, absorbed: chain.filter((c) => c.kind === 'w').map((c) => c.wi) });
    else if (L.rms <= tolFit && L.len >= minSide * 0.06) lines.push({ ...L, absorbed: chain.filter((c) => c.kind === 'w').map((c) => c.wi) });
  });
  const merged = circles;

  const out = walls.slice();
  const tolSnap = minSide * 0.035;
  const snapPt = (x, y) => {
    let best = null;
    out.forEach((s) => {
      [
        [s.x1, s.y1],
        [s.x2, s.y2],
      ].forEach(([ex, ey]) => {
        const d = Math.hypot(ex - x, ey - y);
        if (d <= tolSnap && (!best || d < best.d)) best = { d, x: ex, y: ey };
      });
    });
    if (best) return [best.x, best.y, true];
    // روی بدنه‌ی یک دیوارِ صاف
    out.forEach((s) => {
      if (s.arc) return;
      const dx = s.x2 - s.x1;
      const dy = s.y2 - s.y1;
      const l2 = dx * dx + dy * dy || 1;
      const t = Math.max(0, Math.min(1, ((x - s.x1) * dx + (y - s.y1) * dy) / l2));
      const qx = s.x1 + dx * t;
      const qy = s.y1 + dy * t;
      const d = Math.hypot(qx - x, qy - y);
      if (d <= tolSnap && (!best || d < best.d)) best = { d, x: qx, y: qy };
    });
    return best ? [best.x, best.y, true] : [x, y, false];
  };
  const inkAt = (x, y) => {
    const ix = Math.round(x);
    const iy = Math.round(y);
    return ix >= 0 && iy >= 0 && ix < w && iy < h && thick[iy * w + ix];
  };

  merged.forEach((c) => {
    // ۳) بازه‌ی زاویه‌ای: مکملِ بزرگ‌ترین فاصله بینِ زاویه‌های نقطه‌ها
    const angs = c.px.map(([x, y]) => normAng(Math.atan2(y - c.cy, x - c.cx))).sort((a, b) => a - b);
    let gap = -1;
    let gi = 0;
    angs.forEach((a, i) => {
      const nx = i + 1 < angs.length ? angs[i + 1] : angs[0] + Math.PI * 2;
      if (nx - a > gap) {
        gap = nx - a;
        gi = i;
      }
    });
    let a0 = angs[(gi + 1) % angs.length];
    let span = Math.PI * 2 - gap;
    // ادامه تا جایی که جوهر هست (قسمتی که زیرِ خطِ افقی/عمودیِ اشتباهی یا کنارِ دیوارِ دیگر پنهان شده بود)
    const stepA = Math.min(0.02, 4 / c.R);
    const maxExt = 0.7;
    for (let e = 0; e < maxExt && inkAt(c.cx + Math.cos(a0 - stepA) * c.R, c.cy + Math.sin(a0 - stepA) * c.R); e += stepA) {
      a0 -= stepA;
      span += stepA;
    }
    for (let e = 0; e < maxExt && inkAt(c.cx + Math.cos(a0 + span + stepA) * c.R, c.cy + Math.sin(a0 + span + stepA) * c.R); e += stepA) span += stepA;
    if (span * c.R < minSide * 0.08) return;
    span = Math.min(span, Math.PI * 2 - 0.05);

    // ۴) خطِ صافِ اشتباهیِ روی همین قوس
    const onArc = (x, y) => {
      if (Math.abs(Math.hypot(x - c.cx, y - c.cy) - c.R) > tolFit * 2.5) return false;
      const t = normAng(Math.atan2(y - c.cy, x - c.cx) - a0);
      return t <= span + 0.05 || t >= Math.PI * 2 - 0.05;
    };
    // قوسِ بزرگ‌تر از نیم‌دایره → دو قوس
    const made = [];
    const parts = span > Math.PI * 0.95 ? 2 : 1;
    for (let k = 0; k < parts; k += 1) {
      const s0 = a0 + (span * k) / parts;
      const s1 = a0 + (span * (k + 1)) / parts;
      const [x1, y1, ok1] = snapPt(c.cx + Math.cos(s0) * c.R, c.cy + Math.sin(s0) * c.R);
      const [x2, y2, ok2] = snapPt(c.cx + Math.cos(s1) * c.R, c.cy + Math.sin(s1) * c.R);
      const L = Math.hypot(x2 - x1, y2 - y1);
      if (L < minSide * 0.04) continue;
      // قوسِ کوتاهی که دو سرش به دیوار نرسیده = قوسِ بازشوی در (رسمِ معمولِ پلان)، نه دیوار
      if (parts === 1 && !(ok1 && ok2) && span * c.R < minSide * 0.3) continue;
      const am = (s0 + s1) / 2;
      const ax = c.cx + Math.cos(am) * c.R;
      const ay = c.cy + Math.sin(am) * c.R;
      const nx = -(y2 - y1) / L;
      const ny = (x2 - x1) / L;
      let arc = (ax - (x1 + x2) / 2) * nx + (ay - (y1 + y2) / 2) * ny;
      arc = Math.max(-L / 2, Math.min(L / 2, arc));
      made.push(Math.abs(arc) < L * 0.03 ? { x1, y1, x2, y2 } : { x1, y1, x2, y2, arc });
    }
    if (!made.length) return;
    const absorbed = new Set((c.absorbed || []).map((i) => walls[i]));
    for (let i = out.length - 1; i >= 0; i -= 1) {
      const sg = out[i];
      if (absorbed.has(sg)) {
        out.splice(i, 1);
        continue;
      }
      if (sg.arc) continue;
      if (onArc(sg.x1, sg.y1) && onArc(sg.x2, sg.y2) && onArc((sg.x1 + sg.x2) / 2, (sg.y1 + sg.y2) / 2)) out.splice(i, 1);
    }
    out.push(...made);
  });

  // دیوارهای مورب (صاف ولی نه افقی/عمودی)
  lines.forEach((l) => {
    const absorbed = new Set((l.absorbed || []).map((i) => walls[i]));
    for (let i = out.length - 1; i >= 0; i -= 1) if (absorbed.has(out[i])) out.splice(i, 1);
    const [x1, y1] = snapPt(l.x1, l.y1);
    const [x2, y2] = snapPt(l.x2, l.y2);
    if (Math.hypot(x2 - x1, y2 - y1) >= minSide * 0.05) out.push({ x1, y1, x2, y2 });
  });
  return out;
}

// ---------- ۷-ب) قوس‌ها از «اسکلتِ» خط‌ها ----------
// زانگ-سوئن: خطِ پهن → خطِ یک‌پیکسلی (وسطِ خط)
function skeletonize(src, w, h) {
  const img = new Uint8Array(src);
  const del = [];
  let changed = true;
  const P = (x, y) => (x >= 0 && y >= 0 && x < w && y < h ? img[y * w + x] : 0);
  for (let iter = 0; changed && iter < 40; iter += 1) {
    changed = false;
    for (let pass = 0; pass < 2; pass += 1) {
      del.length = 0;
      for (let y = 1; y < h - 1; y += 1) {
        for (let x = 1; x < w - 1; x += 1) {
          if (!img[y * w + x]) continue;
          const p2 = P(x, y - 1);
          const p3 = P(x + 1, y - 1);
          const p4 = P(x + 1, y);
          const p5 = P(x + 1, y + 1);
          const p6 = P(x, y + 1);
          const p7 = P(x - 1, y + 1);
          const p8 = P(x - 1, y);
          const p9 = P(x - 1, y - 1);
          const B = p2 + p3 + p4 + p5 + p6 + p7 + p8 + p9;
          if (B < 2 || B > 6) continue;
          const seq = [p2, p3, p4, p5, p6, p7, p8, p9, p2];
          let A = 0;
          for (let k = 0; k < 8; k += 1) if (!seq[k] && seq[k + 1]) A += 1;
          if (A !== 1) continue;
          if (pass === 0 ? p2 * p4 * p6 || p4 * p6 * p8 : p2 * p4 * p8 || p2 * p6 * p8) continue;
          del.push(y * w + x);
        }
      }
      if (del.length) changed = true;
      del.forEach((i) => {
        img[i] = 0;
      });
    }
  }
  return img;
}

// همسایه‌ها: اول چهار جهتِ اصلی (پله‌های اسکلت جا نمانند)، بعد قطری‌ها
const NB = [
  [1, 0],
  [0, 1],
  [-1, 0],
  [0, -1],
  [1, 1],
  [-1, 1],
  [-1, -1],
  [1, -1],
];
// به ترتیبِ دور (برای شمردنِ شاخه‌ها)
const RING = [
  [1, 0],
  [1, 1],
  [0, 1],
  [-1, 1],
  [-1, 0],
  [-1, -1],
  [0, -1],
  [1, -1],
];

// اسکلت → مسیرها (از سر/محلِ برخورد تا سر/محلِ برخوردِ بعدی)
function tracePaths(sk, w, h) {
  const deg = new Uint8Array(w * h);
  for (let y = 1; y < h - 1; y += 1) {
    for (let x = 1; x < w - 1; x += 1) {
      if (!sk[y * w + x]) continue;
      // تعدادِ شاخه = تعدادِ «خالی→پر» دورِ پیکسل (پله‌ی اسکلت برخورد حساب نشود)
      let d = 0;
      for (let k = 0; k < 8; k += 1) {
        const [ax, ay] = RING[k];
        const [bx, by] = RING[(k + 1) % 8];
        if (!sk[(y + ay) * w + x + ax] && sk[(y + by) * w + x + bx]) d += 1;
      }
      deg[y * w + x] = d;
    }
  }
  const seen = new Uint8Array(w * h);
  const paths = [];
  const walk = (sx, sy) => {
    const path = [[sx, sy]];
    seen[sy * w + sx] = 1;
    let x = sx;
    let y = sy;
    for (;;) {
      let next = null;
      for (const [dx, dy] of NB) {
        const nx = x + dx;
        const ny = y + dy;
        const i = ny * w + nx;
        if (sk[i] && !seen[i]) {
          next = [nx, ny];
          break;
        }
      }
      if (!next) break;
      const [nx, ny] = next;
      seen[ny * w + nx] = 1;
      path.push(next);
      x = nx;
      y = ny;
      if (deg[ny * w + nx] >= 3) break; // محلِ برخورد
    }
    return path;
  };
  // اول از سرها و کنارِ برخوردها، بعد حلقه‌های بسته
  for (let pass = 0; pass < 2; pass += 1) {
    for (let y = 1; y < h - 1; y += 1) {
      for (let x = 1; x < w - 1; x += 1) {
        const i = y * w + x;
        if (!sk[i] || seen[i]) continue;
        if (pass === 0 && deg[i] !== 1 && deg[i] < 3) continue;
        if (deg[i] >= 3 && pass === 0) {
          // از هر شاخه‌ی برخورد یک مسیر
          seen[i] = 1;
          NB.forEach(([dx, dy]) => {
            const j = (y + dy) * w + x + dx;
            if (sk[j] && !seen[j]) {
              const p = walk(x + dx, y + dy);
              paths.push([[x, y], ...p]);
            }
          });
          continue;
        }
        paths.push(walk(x, y));
      }
    }
  }
  return paths;
}

// خطِ شکسته‌ی ساده (داگلاس-پوکر) → اندیسِ رأس‌ها
function dpIdx(pts, tol) {
  const keep = new Uint8Array(pts.length);
  keep[0] = 1;
  keep[pts.length - 1] = 1;
  const stack = [[0, pts.length - 1]];
  while (stack.length) {
    const [a, b] = stack.pop();
    const [ax, ay] = pts[a];
    const [bx, by] = pts[b];
    const L = Math.hypot(bx - ax, by - ay);
    let md = -1;
    let mi = -1;
    for (let k = a + 1; k < b; k += 1) {
      const [x, y] = pts[k];
      const d = L > 0 ? Math.abs((x - ax) * (by - ay) - (y - ay) * (bx - ax)) / L : Math.hypot(x - ax, y - ay);
      if (d > md) {
        md = d;
        mi = k;
      }
    }
    if (md > tol && mi > a) {
      keep[mi] = 1;
      stack.push([a, mi], [mi, b]);
    }
  }
  const out = [];
  keep.forEach((v, k) => {
    if (v) out.push(k);
  });
  return out;
}

// یک مسیر → قوس‌ها: مسیر به تکه‌های تقریباً صاف شکسته می‌شود؛ از خمیده‌ترین جفتِ تکه‌ها شروع کرده و تا جایی که
// همه‌ی نقطه‌ها روی یک دایره بمانند به دو طرف رشد می‌کنیم (گوشه‌ی تیز یا خطِ صافِ مماس، رشد را متوقف می‌کند)
function arcsInPath(pts, minSide, out) {
  const minLen = minSide * 0.08;
  if (pts.length < 8) return;
  let total = 0;
  for (let i = 1; i < pts.length; i += 1) total += Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]);
  if (total < minLen) return;
  const tol = Math.max(2, minSide * 0.008);
  const idx = dpIdx(pts, tol * 0.6);
  const np = idx.length - 1;
  if (np < 2) return;
  const used = new Uint8Array(np);
  const fit = (a, b) => {
    const sub = pts.slice(idx[a], idx[b] + 1);
    const C = fitCircle(sub);
    if (!C || !(C.R > 0) || C.R > minSide * 3) return null;
    let mx = 0;
    sub.forEach(([x, y]) => {
      mx = Math.max(mx, Math.abs(Math.hypot(x - C.cx, y - C.cy) - C.R));
    });
    return C.rms <= tol * 0.5 && mx <= tol * 1.5 ? { ...C, sub } : null;
  };
  for (let guard = 0; guard < np; guard += 1) {
    let best = null;
    for (let i = 0; i + 1 < np; i += 1) {
      if (used[i] || used[i + 1]) continue;
      const c = fit(i, i + 2);
      if (c && (!best || c.R < best.c.R)) best = { a: i, b: i + 2, c };
    }
    if (!best) break;
    let { a, b, c } = best;
    for (let grew = true; grew; ) {
      grew = false;
      if (b < np && !used[b]) {
        const t = fit(a, b + 1);
        if (t) {
          b += 1;
          c = t;
          grew = true;
        }
      }
      if (a > 0 && !used[a - 1]) {
        const t = fit(a - 1, b);
        if (t) {
          a -= 1;
          c = t;
          grew = true;
        }
      }
    }
    for (let k = a; k < b; k += 1) used[k] = 1;
    // رشدِ ریز (چند نقطه به چند نقطه) تا جایی که قوس واقعاً تمام می‌شود — نه فقط تا سرِ تکه‌ی صاف
    let i0 = idx[a];
    let i1 = idx[b];
    const fitPts = (p0, p1, n0, n1) => {
      // نقطه‌های تازه باید روی همین دایره‌ی فعلی باشند (نه اینکه دایره کج شود تا آن‌ها را بگیرد)
      for (let k = n0; k <= n1; k += 1) {
        if (Math.abs(Math.hypot(pts[k][0] - c.cx, pts[k][1] - c.cy) - c.R) > tol * 0.8) return null;
      }
      const sub = pts.slice(p0, p1 + 1);
      const C = fitCircle(sub);
      if (!C || !(C.R > 0) || C.R > minSide * 3) return null;
      let mx = 0;
      sub.forEach(([x, y]) => {
        mx = Math.max(mx, Math.abs(Math.hypot(x - C.cx, y - C.cy) - C.R));
      });
      return C.rms <= tol * 0.5 && mx <= tol * 1.5 ? { ...C, sub } : null;
    };
    const step = Math.max(2, Math.round(minSide * 0.006));
    for (let more = true; more; ) {
      more = false;
      if (i1 + step < pts.length) {
        const t = fitPts(i0, i1 + step, i1 + 1, i1 + step);
        if (t) {
          i1 += step;
          c = t;
          more = true;
        }
      }
      if (i0 - step >= 0) {
        const t = fitPts(i0 - step, i1, i0 - step, i0 - 1);
        if (t) {
          i0 -= step;
          c = t;
          more = true;
        }
      }
    }
    for (let k = 0; k < np; k += 1) if (idx[k + 1] > i0 + step && idx[k] < i1 - step) used[k] = 1;
    const sub = c.sub;
    const [ax, ay] = sub[0];
    const [bx, by] = sub[sub.length - 1];
    const chord = Math.hypot(bx - ax, by - ay);
    let sag = 0;
    sub.forEach(([x, y]) => {
      const d = chord > 0 ? Math.abs((x - ax) * (by - ay) - (y - ay) * (bx - ax)) / chord : Math.hypot(x - ax, y - ay);
      sag = Math.max(sag, d);
    });
    const len = c.R * Math.max(0.01, 2 * Math.asin(Math.min(1, chord / 2 / c.R)));
    if (sag > tol * 1.5 && sag >= chord * 0.04 && Math.max(len, chord) >= minLen * 0.5 && c.R >= minSide * 0.03) out.push({ cx: c.cx, cy: c.cy, R: c.R, rms: c.rms, pts: sub });
  }
}

function detectArcs(mask, w, h, minSide) {
  const sk = skeletonize(mask, w, h);
  const paths = tracePaths(sk, w, h);
  const found = [];
  paths.forEach((p) => arcsInPath(p, minSide, found));
  // تکه‌های هم‌دایره (یک قوس که برخوردی وسطش افتاده) → یکی
  const merged = [];
  found.forEach((c) => {
    const m = merged.find((o) => Math.hypot(o.cx - c.cx, o.cy - c.cy) < Math.max(o.R, c.R) * 0.1 && Math.abs(o.R - c.R) < Math.max(o.R, c.R) * 0.1);
    if (m) {
      m.pts = m.pts.concat(c.pts);
      Object.assign(m, fitCircle(m.pts) || {});
    } else merged.push({ ...c });
  });
  merged.forEach((c) => {
    // بازه‌ی زاویه‌ای (مکملِ بزرگ‌ترین فاصله)
    const angs = c.pts.map(([x, y]) => normAng(Math.atan2(y - c.cy, x - c.cx))).sort((a, b) => a - b);
    let gap = -1;
    let gi = 0;
    angs.forEach((a, i) => {
      const nx = i + 1 < angs.length ? angs[i + 1] : angs[0] + Math.PI * 2;
      if (nx - a > gap) {
        gap = nx - a;
        gi = i;
      }
    });
    c.a0 = angs[(gi + 1) % angs.length];
    c.span = Math.min(Math.PI * 2 - 0.05, Math.PI * 2 - gap);
  });
  // قوسِ خیلی باز (کمتر از ~۳۲ درجه) = دیوارِ صافی که کج‌وکوله کشیده شده، نه دیوارِ منحنی
  return merged.filter((c) => c.span * c.R >= minSide * 0.08 && c.span >= 0.56);
}

function eraseArcs(mask, w, h, arcs, rad) {
  const out = new Uint8Array(mask);
  arcs.forEach((c) => {
    const x0 = Math.max(0, Math.floor(c.cx - c.R - rad));
    const x1 = Math.min(w - 1, Math.ceil(c.cx + c.R + rad));
    const y0 = Math.max(0, Math.floor(c.cy - c.R - rad));
    const y1 = Math.min(h - 1, Math.ceil(c.cy + c.R + rad));
    for (let y = y0; y <= y1; y += 1) {
      for (let x = x0; x <= x1; x += 1) {
        const i = y * w + x;
        if (!out[i]) continue;
        if (Math.abs(Math.hypot(x - c.cx, y - c.cy) - c.R) > rad) continue;
        const t = normAng(Math.atan2(y - c.cy, x - c.cx) - c.a0);
        if (t <= c.span) out[i] = 0;
      }
    }
  });
  return out;
}

// قوس‌ها → دیوار (سرها روی سر/بدنه‌ی دیوارهای صافِ کنارشان)
function placeArcs(arcs, walls, minSide) {
  if (!arcs.length) return walls;
  const out = walls.slice();
  const tolSnap = minSide * 0.045;
  const snapPt = (x, y) => {
    let best = null;
    out.forEach((s) => {
      [
        [s.x1, s.y1],
        [s.x2, s.y2],
      ].forEach(([ex, ey]) => {
        const d = Math.hypot(ex - x, ey - y);
        if (d <= tolSnap && (!best || d < best.d)) best = { d, x: ex, y: ey };
      });
    });
    if (best) return [best.x, best.y, true];
    out.forEach((s) => {
      if (s.arc) return;
      const dx = s.x2 - s.x1;
      const dy = s.y2 - s.y1;
      const l2 = dx * dx + dy * dy || 1;
      const t = Math.max(0, Math.min(1, ((x - s.x1) * dx + (y - s.y1) * dy) / l2));
      const qx = s.x1 + dx * t;
      const qy = s.y1 + dy * t;
      const d = Math.hypot(qx - x, qy - y);
      if (d <= tolSnap && (!best || d < best.d)) best = { d, x: qx, y: qy };
    });
    return best ? [best.x, best.y, true] : [x, y, false];
  };
  arcs.forEach((c) => {
    const parts = c.span > Math.PI * 0.95 ? 2 : 1;
    for (let k = 0; k < parts; k += 1) {
      const s0 = c.a0 + (c.span * k) / parts;
      const s1 = c.a0 + (c.span * (k + 1)) / parts;
      const [x1, y1, ok1] = snapPt(c.cx + Math.cos(s0) * c.R, c.cy + Math.sin(s0) * c.R);
      const [x2, y2, ok2] = snapPt(c.cx + Math.cos(s1) * c.R, c.cy + Math.sin(s1) * c.R);
      const L = Math.hypot(x2 - x1, y2 - y1);
      if (L < minSide * 0.04) continue;
      // قوسِ کوتاهی که دو سرش به دیوار نرسیده = قوسِ بازشوی در (رسمِ معمولِ پلان)، نه دیوار
      if (parts === 1 && !(ok1 && ok2) && c.span * c.R < minSide * 0.3) continue;
      // قوسِ کوچکِ تنگ (شعاعِ کم) = همیشه قوسِ در
      if (parts === 1 && c.R < minSide * 0.12 && c.span * c.R < minSide * 0.3) continue;
      const am = (s0 + s1) / 2;
      const ax = c.cx + Math.cos(am) * c.R;
      const ay = c.cy + Math.sin(am) * c.R;
      const nx = -(y2 - y1) / L;
      const ny = (x2 - x1) / L;
      let arc = (ax - (x1 + x2) / 2) * nx + (ay - (y1 + y2) / 2) * ny;
      arc = Math.max(-L / 2, Math.min(L / 2, arc));
      out.push(Math.abs(arc) < L * 0.03 ? { x1, y1, x2, y2 } : { x1, y1, x2, y2, arc });
    }
  });
  return out;
}

// دیوارِ مورب که سرش به یک تکه‌ی کوتاهِ افقی/عمودی رسیده (پله‌ی جوهرِ خطِ کج) و آن تکه به دیوارِ دیگری:
// تکه حذف و دیوارِ مورب تا همان دیوار ادامه پیدا می‌کند
function foldStubs(walls, minSide) {
  const tol = minSide * 0.015;
  const maxStub = minSide * 0.08;
  const len = (s) => Math.hypot(s.x2 - s.x1, s.y2 - s.y1);
  const isDiag = (s) => !s.arc && Math.abs(s.x2 - s.x1) > tol && Math.abs(s.y2 - s.y1) > tol;
  const onOther = (x, y, skip) =>
    walls.some((o) => !skip.includes(o) && !o.arc && distSeg(o, x, y) <= tol);
  const drop = new Set();
  const out = walls.map((s) => ({ ...s }));
  out.forEach((d, di) => {
    if (!isDiag(d)) return;
    ['1', '2'].forEach((e) => {
      const ex = d[`x${e}`];
      const ey = d[`y${e}`];
      out.forEach((t, ti) => {
        if (ti === di || drop.has(ti) || t.arc || isDiag(t) || len(t) > maxStub) return;
        let fx;
        let fy;
        if (Math.hypot(t.x1 - ex, t.y1 - ey) <= tol) [fx, fy] = [t.x2, t.y2];
        else if (Math.hypot(t.x2 - ex, t.y2 - ey) <= tol) [fx, fy] = [t.x1, t.y1];
        else return;
        if (!onOther(fx, fy, [walls[ti], walls[di]])) return;
        d[`x${e}`] = fx;
        d[`y${e}`] = fy;
        drop.add(ti);
      });
    });
  });
  return out.filter((_, i) => !drop.has(i));
}

function distSeg(s, x, y) {
  const dx = s.x2 - s.x1;
  const dy = s.y2 - s.y1;
  const l2 = dx * dx + dy * dy || 1;
  const t = Math.max(0, Math.min(1, ((x - s.x1) * dx + (y - s.y1) * dy) / l2));
  return Math.hypot(s.x1 + dx * t - x, s.y1 + dy * t - y);
}

// ---------- ۸) نوشته‌ها ----------
// حرف‌های نزدیکِ هم یک «کلمه» می‌شوند؛ هر کلمه = یک مستطیل. خواندنِ خودِ کلمه را نمی‌کنیم (بدونِ هوش مصنوعی)؛
// فقط جایش مهم است: نوشته‌ای که بیرونِ خانه و کنارِ دیوار است = «ورودی» (در sketchImport)
function findLabels(small, w, h) {
  const minSide = Math.min(w, h);
  const merged = dilate(small, w, h, Math.max(3, Math.round(minSide * 0.016)));
  const { labels, comps } = components(merged, w, h);
  const inkN = new Int32Array(comps.length);
  for (let i = 0; i < small.length; i += 1) if (small[i] && labels[i] >= 0) inkN[labels[i]] += 1;
  const border = minSide * 0.006;
  return comps
    .map((c, k) => ({ ...c, ink: inkN[k] }))
    .filter((c) => {
      const bw = c.x1 - c.x0 + 1;
      const bh = c.y1 - c.y0 + 1;
      const big = Math.max(bw, bh);
      if (big < minSide * 0.03 || big > minSide * 0.4) return false;
      if (c.x0 < border || c.y0 < border || c.x1 > w - border || c.y1 > h - border) return false;
      return c.ink / (bw * bh) < 0.6 && c.ink > minSide * 0.15; // لکه‌ی پُر (سایه) نه؛ نقطه‌ی تنها هم نه
    })
    .map((c) => ({ x0: c.x0, y0: c.y0, x1: c.x1, y1: c.y1, cx: (c.x0 + c.x1) / 2, cy: (c.y0 + c.y1) / 2 }));
}

// دیوارهای پیکسلی → سانتی‌متر، طوری که مساحتِ داخلِ پلان = areaM2 (متراژِ آگهی). مرکزِ پلان روی center.
// computeAreaPx(walls) → مساحتِ فضاهای بسته به پیکسلِ مربع (از spaces.jsx). اگر فضای بسته‌ای نبود، از محدوده‌ی کل
export function scaleToArea(walls, areaM2, computeAreaPx, center = { x: 0, y: 0 }, grid = 5) {
  if (!walls.length) return { walls: [], scale: 1 };
  const xs = walls.flatMap((w) => [w.x1, w.x2]);
  const ys = walls.flatMap((w) => [w.y1, w.y2]);
  const bx = [Math.min(...xs), Math.max(...xs)];
  const by = [Math.min(...ys), Math.max(...ys)];
  let areaPx = computeAreaPx ? computeAreaPx(walls) : 0;
  if (!areaPx || areaPx < (bx[1] - bx[0]) * (by[1] - by[0]) * 0.2) areaPx = (bx[1] - bx[0]) * (by[1] - by[0]) * 0.9;
  const target = (areaM2 > 0 ? areaM2 : 80) * 10000;
  const s = Math.sqrt(target / areaPx);
  const cx = (bx[0] + bx[1]) / 2;
  const cy = (by[0] + by[1]) / 2;
  const snap = (v) => Math.round(v / grid) * grid;
  const out = walls
    .map((w) => ({
      x1: snap(center.x + (w.x1 - cx) * s),
      y1: snap(center.y + (w.y1 - cy) * s),
      x2: snap(center.x + (w.x2 - cx) * s),
      y2: snap(center.y + (w.y2 - cy) * s),
      ...(w.arc ? { arc: Math.round(w.arc * s) } : {}),
      ...(w.virtual ? { virtual: true } : {}),
    }))
    .filter((w) => Math.hypot(w.x2 - w.x1, w.y2 - w.y1) >= 10);
  return { walls: out, scale: s, offset: { x: center.x - cx * s, y: center.y - cy * s } };
}

// فایلِ عکس (دوربین یا گالری) → { width, height, data } — با چرخشِ درستِ EXIF
export async function fileToImageData(file, maxSide = 1600) {
  let bmp;
  try {
    bmp = await createImageBitmap(file, { imageOrientation: 'from-image' });
  } catch (e) {
    bmp = await new Promise((resolve, reject) => {
      const im = new Image();
      im.onload = () => resolve(im);
      im.onerror = reject;
      im.src = URL.createObjectURL(file);
    });
  }
  const s = Math.min(1, maxSide / Math.max(bmp.width, bmp.height));
  const W = Math.round(bmp.width * s);
  const H = Math.round(bmp.height * s);
  const canvas = document.createElement('canvas');
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  ctx.drawImage(bmp, 0, 0, W, H);
  if (bmp.close) bmp.close();
  return ctx.getImageData(0, 0, W, H);
}

export function imageDataToUrl(img, quality = 0.8) {
  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext('2d');
  const id = ctx.createImageData(img.width, img.height);
  id.data.set(img.data);
  ctx.putImageData(id, 0, 0);
  return canvas.toDataURL('image/jpeg', quality);
}
